module.exports = __webpack_public_path__ + "images/home/product/mobile/video-bg-fe1528199ee9243c5403c0e8cdc5ce15.png";